// extracted by mini-css-extract-plugin
export var blog_items = "style-module--blog_items--b7887";
export var blog_textarea_empty = "style-module--blog_textarea_empty--dd966";
export var left = "style-module--left--9c005";
export var more_btn = "style-module--more_btn--75ee5";
export var section_decoration = "style-module--section_decoration--44ae9";
export var section_description = "style-module--section_description--98e8a";
export var section_heading = "style-module--section_heading--5de30";
export var third_section = "style-module--third_section--eac3e";
export var titleH2 = "style-module--titleH2--513ba";
export var titleH2Staff = "style-module--titleH2Staff--3f39b";
export var topArticlesBottomWrapper = "style-module--topArticlesBottomWrapper--22b64";
export var topBusinessSection = "style-module--topBusinessSection--2763d";
export var topBusinessTextWrapper = "style-module--topBusinessTextWrapper--504b0";
export var topBusinessWrapper = "style-module--topBusinessWrapper--d6eb7";
export var topCompanyLeftWrapper = "style-module--topCompanyLeftWrapper--0b849";
export var topCompanyRightWrapper = "style-module--topCompanyRightWrapper--37d97";
export var topCompanySection = "style-module--topCompanySection--1b6f0";
export var topMessageSection = "style-module--topMessageSection--8f767";
export var topPointSection = "style-module--topPointSection--23248";